import ApprovalTable from "../../components/react-table/solicitude-maintenance";

function ApprovalsSolicitudesCompra() {
  return (
    <div>
      <ApprovalTable contextmenu="aprueba" />
    </div>
  );
}

export default ApprovalsSolicitudesCompra;
